import {api} from "../../../../api/API";
import {useGetAll} from "../../../logistics/routes/useGetAll";
import {useProjectId} from "../ProjectName";
import {distinct} from "nate-react-api-helpers";
import {Alert} from "@mui/material";
import {Opening} from "../../../../api/Openings";

function getNames(input: Opening[]) {
    return input.map(v => v.name).join(", ");
}

function getElevNames(input: any[]) {
    return distinct(input.filter(v => !!v)).join(", ")
}

export function WarnMissingScreenElevation() {
    const projectId = useProjectId()

    const list = useGetAll(input => api.openings.list(input as any), {
        project: projectId,
        type: "for-release",
    }, [
        projectId
    ]);

    const missingScreens = list.asList.filter(v => isDoor(v.openingType) && v.screenElevation && !v.screenElevationFile && !v.drwScreenRendering)
    // mirrors the release check: a drw door needs its rendering (it covers both leaves); a legacy
    // door needs a file for each leaf that names an elevation.
    const missingDoors = list.asList.filter(v => isDoor(v.openingType) && (v.drwDoorElevation
        ? !v.drwDoorRendering
        : (v.doorElevation && !v.doorElevationFile) || (v.inactiveDoorElevation && !v.inactiveDoorElevationFile)
    ))
    if(missingScreens.length === 0 && missingDoors.length === 0) return null;

    const missingScreenNames = getElevNames(missingScreens.map(v => v.screenElevation));
    const missingDoorNames = getElevNames(missingDoors.filter(v => !v.drwDoorElevation).flatMap(v => [
        v.doorElevation && !v.doorElevationFile ? v.doorElevation : undefined,
        v.inactiveDoorElevation && !v.inactiveDoorElevationFile ? v.inactiveDoorElevation : undefined,
    ]));

    return (
        <Alert severity="warning">
            {missingScreens.length > 0 && <div>Missing a screen elevation file on the following openings: {getNames(missingScreens)}.</div>}
            {missingScreenNames.length > 0 && <div>Check screen names: "{missingScreenNames}"</div>}
            {missingDoors.length > 0 && <div>Missing a door elevation file on the following openings: {getNames(missingDoors)}.</div>}
            {missingDoorNames.length > 0 && <div>Check door names: "{missingDoorNames}"</div>}
        </Alert>
    )
}

function isDoor(typ: string) {
    switch(typ) {
        case "Single":
        case "Pair":
            return true;
        default:
            return false;
    }
}